import { clsx } from 'clsx';
import type { ReactNode } from 'react';

const styles = {
  success: 'bg-emerald-50 text-emerald-700',
  warning: 'bg-amber-50 text-amber-700',
  danger: 'bg-red-50 text-red-700',
  neutral: 'bg-gray-100 text-gray-600',
} as const;

export function Badge({ tone = 'neutral', className, children }: { tone?: keyof typeof styles; className?: string; children: ReactNode }) {
  return <span className={clsx('inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium', styles[tone], className)}>{children}</span>;
}
